'use client';




import { useNavigate } from "../../hooks/useNavigate";
import { StyledButton } from "../../components/Buttons/StyledButton";

const branding = "/images/branding/branding.png";
import LogoSection from "./LogoSection";
import ColorsSection from "./ColorsSection";
import TypographySection from "./TypographySection";

const BrandGuidelines = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-7xl px-3 sm:px-6 xl:px-10 mx-auto">
      <header className="flex flex-col sm:flex-row items-center justify-between mb-16 mt-4 sm:mt-[10vh]">
        {/* Left - Title & Subtitle */}
        <div className="flex flex-col gap-4 lg:gap-8">
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-semibold">
            Centera Tech <br /> Brand Guidelines
          </h1>
          <p className="font-medium text-lg sm:text-xl lg:text-2xl text-color-2">
            A comprehensive guide to our
            <br /> brand identity & design principles.
          </p>
        </div>

        {/* Right - Logo */}
        <div className="relative w-[90%] sm:w-[50%] overflow-hidden rounded-xl">
          {/* Aspect Ratio Box */}
          <div className="relative w-full pb-[56.25%]">
            <div
              className="absolute inset-0 bg-cover bg-top animate-scroll"
              style={{ backgroundImage: `url(${branding})` }}
            ></div>
          </div>
        </div>
      </header>

      <section className="mt-12 max-w-4xl mx-auto">
        <p className="text-md sm:text-lg text-color-2">
          The <span className="text-color-1">Centera Tech</span> represents
          innovation, efficiency, and seamless technology integration. Its
          forward-moving design reflects progress, while the signature{" "}
          <span className="text-color-1">Centera Green</span> ensures strong
          brand recognition. To maintain its identity, the symbol always appears
          in its defining color.
        </p>

        {/* CTA Button */}
        <div className="mt-3 mb-5 flex justify-end">
          <StyledButton
            text="More About Us..."
            className=""
            onClick={() => {
              navigate("/about-us");
            }}
          />
        </div>
      </section>

      <LogoSection />

      <ColorsSection />

      <TypographySection />
    </div>
  );
};

export default BrandGuidelines;
